import React from 'react';
import { StyleSheet, Text } from 'react-native-web';
import { withRouter } from 'react-router-dom';

import { Card, Header, ButtonImageWithText  } from "../../../components";
import Colors from "../../../constants/Colors";

const JourneySelectionCard = (props) => {

    return (
        <Card containerStyle={{ margin: 20, justifyContent: 'center' }}>

            <Header
                headerText={"Dando o Exemplo"}
                containerPropsStyle={{ backgroundColor: Colors.cardBackgroundColor }}
                textPropsStyle={{ textAlign: 'center' }}
            />

            <ButtonImageWithText
                text={"Acessar"}
                onPress={() => props.history.push('/news')}
                imageSrc={require('../../../imageImports/newsAccessCard.png')}
                propsContainerStyle={styles.buttonContainerStyle}
                propsImageStyle={styles.imageStyle}
                propsTextStyle={styles.textStyle}
            />

            <Card containerStyle={{ backgroundColor: 'white', flexDirection: 'row', padding: 8, margin: 8 }}>
                {/*<Image*/}
                {/*    source={require('../../../img/icons/SobreIcon.png')}*/}
                {/*    style={{ height: 16, width: 16, tintColor: Colors.tabBarNavigationBackground, marginRight: 6 }}*/}
                {/*/>*/}
                <Text selectable={true} style={{ width: '98%' }}>
                    Quer compartilhar suas boas práticas? Envie suas fotos para devoltaaobar@heineken.com.br
                </Text>
            </Card>
        </Card>
    )
}

const styles = StyleSheet.create({
    buttonContainerStyle: {
        height: 120,
        width: "94%",
        flexDirection: 'column',
        backgroundColor: Colors.cardButtonBackground,
        borderRadius: 8,
        margin: 8
    },
    imageStyle: {
        borderRadius: 8,
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0,
        width: '100%',
        height: '82%'
    },
    textStyle: {
        color: Colors.cardButtonFontColor
    }
})

export default withRouter(JourneySelectionCard);
